import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  NOTIFICATION: {
    path: `${baseRoutes.userBaseRoutes}notification`,
  },
};

export default accessRoute;
